import * as types from "./mutation-types";
import Vue from "vue";

export default {
  [types.ADD_FRIEND_LISTS](state, list) {
    state.all = Object.assign({}, state.all, { [list.code]: list });
  },
  [types.SET_FRIEND_LISTS](state, lists) {
    state.all = {};
    lists = lists.map(list => ({ [list.code]: list }));
    state.all = Object.assign({}, state.all, ...lists);
  },
  [types.SET_MY_FRIEND_LIST_ID](state, id) {
    state.myFriendListId = id;
  },
  [types.SET_INVITED_FRIEND_LIST_ID](state, id) {
    state.invitedFriendListId = id;
  },
  [types.RESET_MY_FRIEND_LIST_ID](state) {
    state.myFriendListCode = null;
    state.myFriendListId = null;
  },
  [types.RESET_INVITED_FRIEND_LIST_ID](state) {
    state.invitedFriendListId = null;
  },
  [types.RESET_FRIEND_LISTS](state) {
    state.all = {};
  },
  [types.SET_FRIEND_LIST_LEVELS](state, { id, levels }) {
    state.levels = Object.assign({}, state.levels, { [id]: {} });

    state.levels[id] = Object.assign(
      {},
      state.levels[id],
      ...levels.map(level => ({ [level.id]: level }))
    );
  },
  [types.SET_FRIEND_LIST_PARTICIPANTS](state, { id, participants }) {
    const ps = {};
    participants.forEach(participant => {
      ps[participant.id] = participant;
    });

    Vue.set(state.participants, id, ps);
  },
  [types.DELETE_FRIEND_LIST_PARTICIPANT](state, { friendListId, id }) {
    const participants = state.participants[friendListId];
    const ps = {};

    for (let prop in participants) {
      const participant = participants[prop];

      if (participant.id !== id) {
        ps[participant.id] = participant;
      }
    }

    Vue.set(state.participants, friendListId, ps);
  },
  [types.ADD_FRIEND_LIST_PARTICIPANT](state, { id, participant }) {
    if (!state.participants[id]) {
      state.participants = Object.assign({}, state.participants, { [id]: {} });
    }

    state.participants[id] = Object.assign({}, state.participants[id], {
      [participant.id]: participant,
    });
  },
  [types.ADD_FRIEND_LIST_LEVEL](state, { friendListId, level }) {
    if (!state.levels[friendListId]) {
      state.levels = Object.assign({}, state.levels, { [friendListId]: {} });
    }

    state.levels[friendListId] = Object.assign({}, state.levels[friendListId], {
      [level.id]: level,
    });
  },
};
